<template>
  <div class="search-bar">
    <input
      v-model="data"
      type="text"
      class="search-bar__input"
      @keyup.enter="$emit('submit')"
    >
    <img
      src="/img/icon-search.svg"
      class="search-bar__icon"
      alt=""
      @click="$emit('submit')"
    >
  </div>
</template>
<script>
export default {
  name: 'SearchBar',
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      data: '',
    };
  },
  watch: {
    data() {
      this.$emit('input', this.data);
    },
  },
};
</script>

<style lang="scss" scoped>
.search-bar{
    &__input{
        appearance: none;
        border: none;
        border-bottom: solid 1px black;
        background: none;
        padding-right: 2rem;
        width: 100%;
    }
    &__icon{
        cursor: pointer;
        margin-left: -1.7rem;
        margin-top: -0.5rem;
    }
}
</style>
